module.exports = __webpack_public_path__ + "static/media/logoWhiteLabel.3934d066.png";